import React from "react";
import { FaFileDownload, FaArrowRight } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { Link as ScrollLink } from "react-scroll";
import Typewriter from "typewriter-effect";
import "../App.css";
import { getResumeUrl } from "./Resume";

const Home = () => {
  const resumeUrl = getResumeUrl();
  return (
    <section
      name="home"
      className="relative w-full bg-[#0F172A] text-slate-100 pt-28 pb-12 flex items-center justify-center overflow-hidden"
    >
      {/* Dynamic Background Light Orbs */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[34rem] h-[34rem] bg-blue-600/12 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/3 w-[30rem] h-[30rem] bg-[#00B4DB]/15 rounded-full blur-[140px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 w-full flex flex-col items-center justify-center text-center relative z-10">

        {/* Status Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#00B4DB]/10 border border-[#00B4DB]/30 text-[#00B4DB] text-xs font-semibold uppercase tracking-wider w-fit mb-4 shadow-sm">
          <span className="w-2 h-2 rounded-full bg-[#00B4DB] animate-ping" />
          Open for Developer Opportunities
        </div>

        <h2 className="text-slate-400 text-base sm:text-lg font-medium tracking-wide mb-1 text-center">
          Welcome, I'm
        </h2>

        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-2 leading-tight text-center">
          Partha <span className="gradient-text">Debnath.</span>
        </h1>

        {/* Typewriter Header */}
        <div className="text-xl sm:text-3xl text-slate-200 font-semibold mb-4 flex items-center justify-center gap-2 h-10 text-center">
          <span className="text-[#00B4DB] font-mono">&gt;</span>
          <Typewriter
            options={{
              strings: [
                "Frontend & UI Engineer",
                "WordPress & Web Developer",
              ],
              autoStart: true,
              loop: true,
              delay: 45,
              deleteSpeed: 30,
            }}
          />
        </div>

        <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-8 text-center">
          Specializing in crafting highly responsive, performant, and visual full-stack web applications using modern technologies like <span className="text-white font-semibold">Wordpress, React.js, Node.js, MySQL</span> and <span className="text-white font-semibold">Tailwind CSS</span>.
        </p>

        {/* Action CTAs */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          {/* Resume Button */}
          <a
            href={resumeUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl bg-gradient-to-r from-blue-600 via-sky-600 to-[#00B4DB] text-white font-bold text-sm hover:opacity-95 shadow-lg shadow-blue-500/25 transition-all transform hover:-translate-y-0.5"
          >
            <FaFileDownload size={16} /> Get Resume
          </a>

          {/* WhatsApp CTA */}
          <a
            href="https://wa.me/9476316652"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#1E293B] text-slate-100 border border-slate-700 hover:border-[#00B4DB] hover:text-[#00B4DB] font-semibold text-sm backdrop-blur-md transition-all transform hover:-translate-y-0.5 shadow-sm"
          >
            <BsWhatsapp size={16} className="text-[#00B4DB]" /> WhatsApp Me
          </a>

          {/* Scroll to Work */}
          <ScrollLink
            to="work"
            smooth={true}
            duration={500}
            className="inline-flex items-center gap-2 px-5 py-3.5 text-slate-300 hover:text-[#00B4DB] font-medium text-sm transition-colors cursor-pointer group"
          >
            Explore Work <FaArrowRight size={14} className="group-hover:translate-x-1 transition-transform text-[#00B4DB]" />
          </ScrollLink>
        </div>

      </div>
    </section>
  );
};

export default Home;
